export interface KeyboardState {
  active: boolean;
  connected: boolean;
}

function isEditableTarget(ev: KeyboardEvent): boolean {
  const path = ev.composedPath();
  for (const el of path) {
    const e = el as HTMLElement;
    if (!e || typeof e.tagName !== "string") continue;
    const tag = e.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
    if (e.isContentEditable) return true;
  }
  return false;
}

export function bindKeyboard(
  getState: () => KeyboardState,
  handlers: { end: () => void; toggleMute: () => void },
): () => void {
  function onKeyDown(ev: KeyboardEvent): void {
    if (isEditableTarget(ev)) return;
    // Modified presses (Cmd+M, Ctrl+M, Alt+M) are host/OS shortcuts, not ours.
    if (ev.metaKey || ev.ctrlKey || ev.altKey) return;
    const { active, connected } = getState();
    if (ev.key === "Escape" && active) {
      handlers.end();
    } else if ((ev.key === "m" || ev.key === "M") && connected) {
      handlers.toggleMute();
    }
  }

  window.addEventListener("keydown", onKeyDown);
  return () => window.removeEventListener("keydown", onKeyDown);
}
